import { Routes, Route } from "react-router";
import { AnalyticsLayout } from "./components/AnalyticsLayout";
import Overview from "./pages/Overview";
import Screens from "./pages/Screens";
import Devices from "./pages/Devices";
import Geography from "./pages/Geography";
import Sessions from "./pages/Sessions";
import Errors from "./pages/Errors";

/**
 * Analytics routes - Usage analytics dashboards
 * Protected by AnalystGuard (admin or analyst roles)
 */
export default function AnalyticsRoutes() {
  return (
    <Routes>
      <Route element={<AnalyticsLayout />}>
        <Route index element={<Overview />} />
        <Route path="screens" element={<Screens />} />
        <Route path="devices" element={<Devices />} />
        <Route path="geography" element={<Geography />} />
        <Route path="sessions" element={<Sessions />} />
        <Route path="errors" element={<Errors />} />
      </Route>
    </Routes>
  );
}
